<app-loading *ngIf="contentReady"></app-loading>
<div class="account-container" style="margin-bottom: 70px;">
  <!-- Header -->
  <div class="account-header cart-summary">
    <div class="user-info">
      <div class="useravatar">
        <img style="width: 90%;" src="/assets/e-commerce/icons/48.webp" alt="" />
      </div>
      <div class="user-text">
        <h4>
          {{ "welcome" | transloco }}
          :
          {{userfirstname}}
        </h4>
        <p>{{userPhone}}</p>
      </div>
    </div>
  </div>

  <!-- Title
  <h5 class="section-title"> {{ "Profile" | transloco }}</h5> -->

  <!-- Menu List -->
  <div class="account-menu">
    <div class="menu-item" routerLink="/change-password">
      <span>
        <img class="profile-icon" src="/assets/e-commerce/icons/51.webp">
        {{"Change Password" | transloco}}
      </span>

      <i class="icon">
        @if(isAr){
        <img class="profile-icon" src="/assets/e-commerce/icons/61.webp">
        }
        @else{
        <img class="profile-icon" src="/assets/e-commerce/icons/60.webp">
        }
      </i>
    </div>
    <div class="menu-item" routerLink="/notifications">
      <span>
        <img class="profile-icon" src="/assets/e-commerce/icons/55.webp">
        {{"notification" | transloco}}</span>
      <i class="icon">
        @if(isAr){
        <img class="profile-icon" src="/assets/e-commerce/icons/61.webp">
        }
        @else{
        <img class="profile-icon" src="/assets/e-commerce/icons/60.webp">
        }
      </i>
    </div>
    <div class="menu-item" routerLink="/address">
      <span>
        <img class="profile-icon" src="/assets/e-commerce/icons/54.webp">
        {{"myaddresses" | transloco}}</span>
      <i class="icon">
        @if(isAr){
        <img class="profile-icon" src="/assets/e-commerce/icons/61.webp">
        }
        @else{
        <img class="profile-icon" src="/assets/e-commerce/icons/60.webp">
        }
      </i>
    </div>
    <div class="menu-item" routerLink="/wallet">
      <span>
        <img class="profile-icon" src="/assets/e-commerce/icons/53.webp">
        {{"wallet" | transloco}}</span>
      <span class="balance">{{balance}} {{ "egpe" |
        transloco }}</span>
    </div>
    <div class="menu-item" (click)="toggleLanguage()">
      <span>
        <img class="profile-icon" src="/assets/e-commerce/icons/59.webp">
        {{"changelang" | transloco}}</span>
      <span>
        {{"Change to Arabic" | transloco}}

      </span>
    </div>
    <div class="menu-item" routerLink="/contact-us">
      <span>
        <img class="profile-icon" src="/assets/e-commerce/icons/64.webp">
        {{"Contact Us" | transloco}}</span>
      <i class="icon">
        @if(isAr){
        <img class="profile-icon" src="/assets/e-commerce/icons/61.webp">
        }
        @else{
        <img class="profile-icon" src="/assets/e-commerce/icons/60.webp">
        }
      </i>
    </div>
    <div class="menu-item" routerLink="/about-us">
      <span>
        <img class="profile-icon" src="/assets/e-commerce/icons/63.webp">
        {{"About Us" | transloco}} </span>
      <i class="icon">
        @if(isAr){
        <img class="profile-icon" src="/assets/e-commerce/icons/61.webp">
        }
        @else{
        <img class="profile-icon" src="/assets/e-commerce/icons/60.webp">
        }
      </i>
    </div>
    <div class="menu-item" routerLink="/refund-policy">
      <span>
        <img class="profile-icon" src="/assets/e-commerce/icons/63.webp">
        {{"refund" | transloco}} </span>
      <i class="icon">
        @if(isAr){
        <img class="profile-icon" src="/assets/e-commerce/icons/61.webp">
        }
        @else{
        <img class="profile-icon" src="/assets/e-commerce/icons/60.webp">
        }
      </i>
    </div>
  </div>

  <!-- Actions -->
  <div class="account-actions cart-summary">
    <button (click)="logout()" class="checkout-btn clear-cart">
      {{ "Log out" | transloco }}
    </button>

    <!-- <button class="checkout-btn clear-cart"
      style="color: white!important;background-color: #e91e63 !important;  text-transform: capitalize;">
      {{ "deletemyaccount" | transloco }}
    </button> -->
  </div>
</div>